<template>
  <div class="footer">
    <div class="contacts-block">
      <ul class="contact">
        <li v-for="item in contacts" :key="item.img">
          <img class="contact-img" :src="item.img" alt="contacts" />
          <a class="contact-link" :href="item.href">{{ item.text }}</a>
        </li>
      </ul>
      <ul class="socials">
        <li>
          <a
            href="https://www.linkedin.com/shareArticle?mini=true&url=https://nordic-dev.os-system.com/&title=&summary=&source="
          >
            <img :src="socials[0]" class="socials-img" alt="some alt" />
          </a>
        </li>
        <li>
          <div data-href="https://nordic-dev.os-system.com">
            <a
              href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fnordic-dev.os-system.com%2F&amp;src=sdkpreparse"
            >
              <div>
                <img :src="socials[1]" class="socials-img" alt="some alt" />
              </div>
            </a>
          </div>
        </li>

        <!-- <img class="solials-img" :src="item" alt="contacts" /> -->
      </ul>
    </div>
  </div>
</template>

<script>
import { contacts, socials } from "../configs/footer";

export default {
  name: "myfooter",
  data: () => {
    return {
      contacts,
      socials,
    };
  },
};
</script>

<style scoped lang="scss">
.footer {
  height: 129px;
  background: #023a5a;
  box-shadow: 0px -15px 25px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 1020px) {
    height: 205px;
  }

  @media screen and (max-width: 767px) {
    height: 156px;
  }
}

.contacts-block {
  display: flex;
  align-items: center;

  @media screen and (max-width: 1020px) {
    width: 100%;
    max-width: 737px;
    justify-content: space-between;
    align-items: flex-end;
  }
}

.socials-img {
  width: 34px;

  @media screen and (max-width: 767px) {
    width: 21px;
  }
}

.contact {
  display: flex;
  width: 786.44px;
  height: 36px;
  justify-content: space-between;
  margin-right: 170px;
  @media screen and (max-width: 1130px) {
    width: 768px;
    margin-right: 45px;
  }

  @media screen and (max-width: 1020px) {
    display: flex;
    flex-direction: column;
    height: 142px;
    width: 262px;
    margin-left: 50px;
  }

  @media screen and (max-width: 767px) {
    margin-left: 20px;
    max-height: 98px;
  }

  @media screen and (max-width: 375px) {
    margin-right: 0;
  }

  li {
    display: flex;
    align-items: center;

    @media screen and (max-width: 767px) {
      img {
        width: 20px;
      }

      a {
        font-size: 18px;
        line-height: 21px;
        @media screen and (max-width: 375px) {
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
  }
}

.contact-link {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  color: #ffffff;
  text-decoration: none;
}

.socials {
  display: flex;
  justify-content: space-between;
  display: flex;

  li {
    &:nth-child(1) {
      margin-right: 30px;
    }
  }

  @media screen and (max-width: 1020px) {
    margin-right: 50px;
  }

  @media screen and (max-width: 767px) {
    margin-right: 20px;
    li {
      &:nth-child(1) {
        margin-right: 20px;
      }
    }
  }
}

.contact-img {
  margin-right: 18px;
  @media screen and (max-width: 375px) {
    margin-right: 32px;
  }
}
</style>
